import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import type { RootState } from "single-spa/store/types";

const selectImpersonationState = createStatePropertySelector((state: RootState) => state.impersonation);
export const selectImpersonateMode = selectImpersonationState("impersonateMode");
